import Modal from '@atoms/Modal/Modal';
import { IImage } from '@models/IImage';
import { IMeta } from '@models/IMeta';
import { ISignupForm } from '@models/ISignupForm';
import ErrorBannerNotificationEnum from '@models/enums/ErrorBannerNotificationEnum';
import Banner from '@molecules/Banner/Banner';
import SignupForm from '@organisms/SignupForm/SignupForm';
import signupFormGetProps from '@services/signupFormGetProps';
import useErrorNotificationStore from '@state/ErrorBannerNotificationDisplayStore';
import { useState } from 'react';

interface Props {
  readonly contactList?: string;
  readonly title: string;
  readonly titleTextColour: 'black' | 'white';
  readonly linkText: string;
  readonly image: IImage;
  readonly formEndpoint: string;
  readonly disabled: boolean;
  readonly meta?: IMeta;
}

const NewsletterSignupBanner = ({
  contactList,
  title,
  titleTextColour,
  linkText,
  image,
  formEndpoint,
  disabled,
  meta,
}: Props) => {
  const [isSignupFormModalOpen, setIsSignupFormModalOpen] = useState(false);
  const [signupFormData, setSignupFormData] = useState<ISignupForm>();

  const { setErrorBannerNotification } = useErrorNotificationStore();

  const onCallback = async () => {
    try {
      const signupFormResponse = await signupFormGetProps(formEndpoint);

      setSignupFormData(signupFormResponse);
      setIsSignupFormModalOpen(true);
    } catch {
      setErrorBannerNotification(
        ErrorBannerNotificationEnum.NewsletterSignupBanner
      );
    }
  };

  if (disabled) return null;

  return (
    <>
      <Banner
        title={title}
        titleTextColour={titleTextColour}
        linkText={linkText}
        image={image}
        ctaCallback={onCallback}
        dataTestId="CT-05-A-Newsletter-Signup-Banner"
        meta={meta}
      />

      {signupFormData && (
        <Modal
          isOpen={isSignupFormModalOpen}
          setIsOpen={setIsSignupFormModalOpen}
          showCloseButton={false}
          contentClasses="py-4"
        >
          <SignupForm
            {...signupFormData}
            contactList={contactList}
            onClose={() => setIsSignupFormModalOpen(!isSignupFormModalOpen)}
          />
        </Modal>
      )}
    </>
  );
};

export default NewsletterSignupBanner;
